<div *ngIf="isCheckBoxModalOpen" [config]="{ show: isCheckBoxModalOpen, backdrop: 'static' }"
  (onHidden)="onCheckBoxModalHidden()" bsModal #autoShownModal="bs-modal" class="modal fade checkbox-select-container"
  tabindex="-1" role="dialog" aria-hidden="true">
  <div class="custom-theme-modal modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content pb-3">
      <div class="modal-header d-block py-3 bg-white border-bottom">
        <!-- Head -->
        <div class="row">
          <div *ngIf="!mobileBackButtonFlag" class="col-8 pr-0">
            <span class="mt-2 d-flex">
              <img src="assets/themes/icons/back-arrow.svg" alt="back icon" (click)="onCheckBoxModalHidden()"
                class="mr-2 cursor-pointer" />
              <span class="heading-4">
                <span class="color-black-700 mr-2">{{popupLabel}}</span>
                <span *ngIf="!isSpecialitySelectionOpen">({{memberCount}}/{{selectedLimit}})</span>
                <span *ngIf="isSpecialitySelectionOpen">({{selectedListLength}}/{{selectedLimit}})</span>
              </span>
            </span>
          </div>
          <div *ngIf="mobileBackButtonFlag" class="col-8 pr-0">
            <div class="row">
              <div class="col-4 pr-0">
                <span class="heading-4 mt-2 d-flex cursor-pointer">
                  <img src="assets/themes/icons/back-arrow.svg" alt="back icon" (click)="showOriginalList()"
                    class="mr-2" />
                  {{mls.languageText.community.key28}}
                </span>
              </div>
              <div class="col-8 pr-0 text-center">
                <span class="primary-small mt-2 d-inline-block">{{mls.languageText.community.key52}}
                  ({{selectedListLength}}) </span>
              </div>
            </div>
          </div>

          <div class="col-4 col-md-4 text-right">
            <button [disabled]="!isButtonDisable" [ngClass]=" isButtonDisable ? 'filled' : 'filled-disabled'"
              (click)="selectionComplete()" class="btn-design small position-relative">
              <span>
                {{completeSelectionLabel}}
              </span>
            </button>
          </div>
        </div>
      </div>
      <ng-content></ng-content>
    </div>
  </div>
</div>